import React from "react";
import { useGlobalContext } from "../context";
import { NavLink } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const Sidebar = () => {
  const { closeSidebar, sidebarOn } = useGlobalContext();

  return (
    <nav className={sidebarOn ? "sidebar show-sidebar" : "sidebar"}>
      <FaTimes onClick={closeSidebar} className="sidebar-times" />
      <ul className="sidebar-list">
        <li className="sidebar-list-item">
          <NavLink
            to="/home"
            className="sidebar-list-item-link"
            onClick={closeSidebar}
          >
            Home
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/about"
            className="sidebar-list-item-link"
            onClick={closeSidebar}
          >
            About
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/menu"
            className="sidebar-list-item-link"
            onClick={closeSidebar}
          >
            Menu
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/contact"
            className="sidebar-list-item-link"
            onClick={closeSidebar}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
